import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../../services/employee.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms'

@Component({
  selector: 'app-staff-registration',
  templateUrl: './staff-registration.component.html',
  styleUrls: ['./staff-registration.component.scss']
})
export class StaffRegistrationComponent implements OnInit {

  public formSubmitAttempt: boolean;
  registertionImage: string;
  documentfiles: File;
  imagefile = [];
  filesToUpload = [];
  dob;
  signupForm: FormGroup;
  FirstName: string = "";
  LastName: string = "";
  Email: string = "";
  Password: string = "";
  private countryCode: string;
  private homecountryCode: string;
  private workcountryCode: string;
  public isSlide: boolean = false;
  maxDate = {};

  constructor(private _employeeService: EmployeeService, private router: Router, private fb: FormBuilder, ) {
    this.registertionImage = '../../../assets/images/profile.jpg';
    const current = new Date();
    this.maxDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };

    this.signupForm = fb.group({
      firstName: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.minLength(1)])],
      lastName: ['', [Validators.required, Validators.maxLength(19)]],
      email: ['', [
        // Validators.required,
        Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$")
      ]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(30)
      ]],
      mobile: ['', [Validators.required, Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9]+")]],
      home: ['', [Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9]+")]],
      work: ['', [Validators.maxLength(15), Validators.minLength(1), Validators.pattern("[0-9]+")]],
      specialityYear: [],
      degreeDesignation: [],
      currentRegistration: [],
      registrationNumber: [],
      licensingBody: [],
      yearRegistered: [],
      city: [],
      speciality: [],
      confirmPassword: ['', Validators.required],
      dob: [],
      documentfiles: [],
      institution: [],
      specialInterest: [],
      countrycode: [],
      homecountrycode: [],
      workcountrycode: []
    }, { validator: this.checkPasswords })
  }

  checkPasswords(AC: AbstractControl) { // here we have the 'passwords' group
    let password = AC.get('password').value; // to get value in input tag
    let confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
    if (password != confirmPassword) {
      console.log('false');
      AC.get('confirmPassword').setErrors({ MatchPassword: true })
    } else {
      console.log('true');
      return null
    }
  }

  ngOnInit() {

  }

  registerEmployee(employeeForm: FormGroup) {
    const files: Array<File> = this.filesToUpload;
    console.log('files')
    console.log(files)
    console.log(employeeForm.value);
    this.formSubmitAttempt = true;
    if (employeeForm.value.dob) {
      let formateddate = employeeForm.value.dob;
      employeeForm.value.dob = new Date(formateddate.year + '-' + formateddate.month + '-' + formateddate.day)
    }
    else {
      employeeForm.value.dob = null;
    }
    employeeForm.value.usertype = 3;
    employeeForm.value.countrycode = (employeeForm.value.mobile == null || employeeForm.value.mobile == '') ? null : (this.countryCode == null || this.countryCode == '') ? "254" : this.countryCode;
    employeeForm.value.homecountrycode = (employeeForm.value.home == null || employeeForm.value.home == '') ? null : (this.homecountryCode == null || this.homecountryCode == '') ? "254" : this.homecountryCode;
    employeeForm.value.workcountrycode = (employeeForm.value.work == null || employeeForm.value.work == '') ? null : (this.workcountryCode == null || this.workcountryCode == '') ? "254" : this.workcountryCode;
    console.log(employeeForm.value);
    if (employeeForm.invalid) {
      return;
    }
    else {

      this._employeeService.saveEmployee(employeeForm.value, this.imagefile).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("staff member registered Sucessfully")
            this.router.navigate(['stafflist']);
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          alert(error)
          console.log(error)
        });
    }
  }


  onFileChange(event: any) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      var img = document.querySelector("#preview img");
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.registertionImage = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
      this.filesToUpload = <Array<File>>event.target.files;
      this.imagefile = event.target.files[0]['imagefile'];

    }
  }

  onDocumentUpload(event: any) {
    let files = [].slice.call(event.target.files);
    this.documentfiles = files;
  }

  reset() {
    this.signupForm.reset();
    this.formSubmitAttempt = false;

  }

  telInputObject(obj) {
    console.log(obj);
    obj.intlTelInput('setCountry', 'ke');
  }

  onCountryChange(obj) {
    this.countryCode = obj.dialCode
    console.log(obj);
  }

  onHomeCountryChange(obj) {
    this.homecountryCode = obj.dialCode
    console.log(obj);
  }
  onWorkCountryChange(obj) {
    this.workcountryCode = obj.dialCode
    console.log(obj);
  }

  getNumber(obj) {
    console.log(obj);
  }
  hasError(obj) {
    console.log(obj)
  }

  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/admin/staff-registration/staff-registration.component.ts